'use strict';
const serviceCards = {

	langaugeLinks: document.querySelectorAll('.gt_options a'),
	card: document.querySelectorAll('.service-cards__col'),
	cardTextWap: document.querySelectorAll('.service-cards__content'),
	cardTitle: document.querySelectorAll('.service-cards__title'),

	init: function() {
		serviceCards.setHeight();
		serviceCards.bindEvents();
		// serviceCards.cardHover();
	},

	bindEvents: function() {
		window.addEventListener('resize', function() {
			serviceCards.setHeight();
		});

		serviceCards.langaugeLinks.forEach(link => {
			link.addEventListener('click', () => {
				serviceCards.setHeight();
			});
		});
	},

	setHeight: function() {
		setTimeout(() => {
			serviceCards.cardTextWap.forEach(el => {
				const cardTextWrap = el.querySelector('.service-cards__text-wrap');
				const cardText = el.querySelector('.service-cards__text');
				const textHeight = cardText.offsetHeight;

				cardTextWrap.style.maxHeight = textHeight + 'px';
			});
		}, 1500);
	},

	// cardHover: function() {
	// 	serviceCards.card.forEach(el => {
	// 		el.addEventListener('mouseover', function() {
	// 			serviceCards.card.forEach(card => {
	// 				if (card !== el) {
	// 					// card.style.backgroundColor = 'transparent';
	// 				}
	// 			});
	// 		});
	// 	});
	// }
};

export default serviceCards;
